export function sortCollectionItems(items) {
    items.sort((a, b) => a.relativePath < b.relativePath ? -1 : 1);
}
//# sourceMappingURL=sortCollectionItems.js.map